// extracted by mini-css-extract-plugin
export default {"ListOfForumsRight":"qh_a","ListOfForumsRight__brandDaysPosts":"qh_b bhr_sw"};